export const initialState = {
    hasError: false,
    errorText: "",
};
